import React from 'react'
import Text from '@amzn/meridian/text'
import Button from '@amzn/meridian/button'
import Column from '@amzn/meridian/column'
import Alert from '@amzn/meridian/alert'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { RETRY_BUTTON } from '../constants'

export interface IErrorMessageProps {
    /** Panther string identifier of the error to show. */
    messageStringId: string
    onRetry?: () => void
}

/**
 * ErrorMessage Component
 *
 * Displays an error message with an optional retry button when API calls fail.
 */
export const ErrorMessage: React.FC<IErrorMessageProps> = ({ messageStringId, onRetry }) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
      <Column alignmentHorizontal="center" spacingInset="400">
          <Alert type="error">
            <Text>{t(bundle, messageStringId)}</Text>
          </Alert>
        {onRetry && (
          <Button onClick={onRetry}>
            {t(bundle, RETRY_BUTTON)}
          </Button>
        )}
      </Column>
    )
}
